import { Button, Flex, Link, Text } from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { useContext, useEffect, useState } from 'react';
import { BrowserView } from 'react-device-detect';
import { FormattedMessage } from 'react-intl';
import { Link as ReactRouterLink } from 'react-router-dom';
import { isAuthenticated } from '../auth/keycloak';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';
import { AppVersion } from '../component/settingsComponents/AppVersion';
import { DarkMode } from '../component/settingsComponents/DarkMode';
import { Zendesk } from '../component/settingsComponents/Zendesk';
import NotificationContext from '../context/NotificationContext';

export const Settings = () => {
    // const { isLoadFromCache } = useContext(PageDataContext);
    const { keycloak } = useKeycloak();

    // const intl = useIntl();

    const [permissionStatus, SetPermissionStatus] = useState<string>('default');

    const { openModal } = useContext(NotificationContext);

    useEffect(() => {
        const setup = async () => {
            //TODO: make call to back end to check if user is a member, then setIsSubscribed here
        };

        setup();
    }, []);

    useEffect(() => {
        if ('Notification' in window) {
            SetPermissionStatus(Notification.permission);
        }
    }, []);

    const basePageUnauthenticated = () => (
        <Flex className="settings-container">
            <AppVersion />
            <Zendesk />
            <Flex className="divider" />
            <DarkMode />

            <Flex className="divider" />
            <Link as={ReactRouterLink} to={'/privacy-policy'}>
                <Button className={'settings-button'}>
                    <FormattedMessage
                        id="settings-privacy-policy"
                        defaultMessage={'Privacy Policy'}
                    />
                </Button>
            </Link>
            <Link as={ReactRouterLink} to={'/terms-and-conditions'}>
                <Button className={'settings-button'}>
                    <FormattedMessage id="settings-terms" defaultMessage={'Terms and Conditions'} />
                </Button>
            </Link>
            <Link as={ReactRouterLink} to={'/code-of-conduct'}>
                <Button className={'settings-button'}>
                    <FormattedMessage id="settings-conduct" defaultMessage={'Code of Conduct'} />
                </Button>
            </Link>
            <Flex className="divider" />
        </Flex>
    );

    const basePageAuthenticated = () => (
        <Flex className="settings-container">
            <AppVersion />
            <Zendesk />

            <Flex className="divider" />
            <DarkMode />

            {permissionStatus === 'default' && (
                <>
                    <Flex className="divider" />
                    <Text className="settings-membership-title">Push Notifications</Text>
                    <Button onClick={() => openModal()} className={'settings-button'}>
                        Enable Push Notifications
                    </Button>
                </>
            )}

            {permissionStatus === 'denied' && (
                <>
                    <Flex className="divider" />
                    <Text>
                        Push notification permission has been previously denied. If you wish to
                        receive push notifications please go to your browser settings to re-enable
                        them.
                    </Text>
                </>
            )}

            <Flex className="divider" />
            <Flex className="settings-membership-container">
                <Text className="settings-membership-title">
                    <FormattedMessage
                        id="settings-membership-title"
                        defaultMessage={'My Membership'}
                    />
                </Text>
                <Text>Coming Soon!</Text>
                <Flex className="divider" />
                {/* {isAuthenticated(keycloak) && <Membership keycloak={keycloak} />} */}
            </Flex>
            <Flex className="settings-membership-button-container">
                {/* {!isSubscribed && (
                    <Button
                        className="settings-button"
                        onClick={handlePurchaseMembership}
                        isDisabled={true}
                    >
                        <FormattedMessage
                            id="settings-membership-purchase-membership"
                            defaultMessage={'Become a member for $9.99'}
                        />
                    </Button>
                )} */}
                <Button className="settings-button" onClick={() => keycloak.accountManagement()}>
                    Manage Account
                </Button>
            </Flex>

            {/* <Flex className="divider" />
            <ManageCommunications email={userProfile?.email || ''} keycloak={keycloak} /> */}

            <Flex className="divider" />
            <Link as={ReactRouterLink} to={'/privacy-policy'}>
                <Button className={'settings-button'}>
                    <FormattedMessage
                        id="settings-privacy-policy"
                        defaultMessage={'Privacy Policy'}
                    />
                </Button>
            </Link>
            <Link as={ReactRouterLink} to={'/terms-and-conditions'}>
                <Button className={'settings-button'}>
                    <FormattedMessage id="settings-terms" defaultMessage={'Terms and Conditions'} />
                </Button>
            </Link>
            <Link as={ReactRouterLink} to={'/code-of-conduct'}>
                <Button className={'settings-button'}>
                    <FormattedMessage id="settings-conduct" defaultMessage={'Code of Conduct'} />
                </Button>
            </Link>

            <Flex className="divider" />
            <Button
                className={'signout-button'}
                onClick={() => keycloak.logout({ redirectUri: window.location.origin })}
            >
                <FormattedMessage id="settings-sign-out" defaultMessage={'Sign Out'} />
            </Button>
            <Flex className="divider" />
        </Flex>
    );

    // const getSubheader = (subtitle: string, prevStage: number): JSX.Element => (
    //     <Flex className="settings-manage-membership-subheader">
    //         <Flex className="settings-manage-membership-subheader-buttons">
    //             <FaChevronLeft
    //                 className="settings-manage-membership-back"
    //                 onClick={() => setStage(prevStage)}
    //             />

    //             <Text>{subtitle}</Text>

    //             <div />
    //         </Flex>

    //         <Flex className="divider" />
    //     </Flex>
    // );

    return (
        <>
            <BrowserView>
                <BrowserTopBar color="#FFF" isLoading={false}>
                    <Flex className={'settings-title browser-view-title'}>
                        <FormattedMessage id="global-settings" defaultMessage={'SETTINGS'} />
                    </Flex>
                </BrowserTopBar>
                <BrowserSidebar />
                <Flex className="browser-content settings-browser">
                    {isAuthenticated(keycloak)
                        ? basePageAuthenticated()
                        : basePageUnauthenticated()}
                </Flex>
            </BrowserView>
            <MobileViewPage
                title="SETTINGS"
                titleColor="#FFF"
                titleBackgroundColor="#6867DD"
                isLoading={false}
            >
                {isAuthenticated(keycloak) ? basePageAuthenticated() : basePageUnauthenticated()}
            </MobileViewPage>
        </>
    );
};
